import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { AdminGuard } from './services/admin-guard.service';
import { LogoutComponent } from './logout/logout.component';
import { SharedModule } from '../shared/shared.module';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { LoginHeaderComponent } from './login-header/login-header.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
// import { Ng2Bs3ModalModule } from 'ng2-bs3-modal';
import { ModalModule } from 'ngx-modal';
import { HasPermissionDirective } from 'app/login/has-permission/has-permission';
import { SsoComponent } from './sso/sso.component';
import { ClientDialogComponent } from './client-dialog/client-dialog.component';
import { AmplifyAngularModule, AmplifyService, AmplifyModules } from 'aws-amplify-angular';
import Auth from '@aws-amplify/auth';

@NgModule({
  imports: [
    RouterModule
    // ,Ng2Bs3ModalModule 
    ,ModalModule
    ,AmplifyAngularModule
    ,SharedModule
  ],
  declarations: [LoginComponent, LogoutComponent, AdminLoginComponent, LoginHeaderComponent, LoginDialogComponent, HasPermissionDirective, SsoComponent, ClientDialogComponent]
  ,providers: [AuthService, AuthGuard, AdminGuard, {
    provide: AmplifyService,
      useFactory:  () => {
        return AmplifyModules({
          Auth
        });
      }
  }]
  ,exports: [LogoutComponent, LoginComponent, AdminLoginComponent, LoginDialogComponent, ClientDialogComponent, HasPermissionDirective, SsoComponent]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts